import { thunk } from 'redux-thunk';
import promise from 'redux-promise-middleware';
import { createStore, applyMiddleware, compose } from 'redux';
import _  from 'lodash';

import createRootReducer from './rootReducer';

type StoreParams = {
    initialState?: { [key: string]: any };
    middleware?: any[];
    /** When true (SSR + hydrateRoot), do not overlay localStorage — fixes React hydration #418 */
    preferPreloadedOverPersist?: boolean;
};

export const loadState = (initialState) => {
    try {
      const serializedState = localStorage.getItem('state');

      if (serializedState === null) {
        return initialState;
      }
      var storedValue = JSON.parse(serializedState);

      return storedValue;
    } catch (err) {
      // No localStorage (SSR/Node) or parse error — keep caller-provided initial state
      return initialState;
    }
  };
  
  export const saveState = (state) => {
    try {
      const serializedState = JSON.stringify(state);
      localStorage.setItem('state', serializedState);
    } catch (err) {
      // die
    }
  };

export const configureStore = ({
    initialState,
    middleware = [],
    preferPreloadedOverPersist = false,
}: StoreParams) => {
    const devtools =
        typeof window !== 'undefined' &&
        typeof window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ === 'function' &&
        window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ actionsBlacklist: [] });

    const composeEnhancers = devtools || compose;

    // hydrateRoot: first client render must match SSR HTML. __PRELOADED_STATE__ is authoritative
    // until hydration completes; replacing it with localStorage first causes error #418.
    if (!(preferPreloadedOverPersist && initialState != null)) {
        initialState = loadState(initialState);
    }

const store = createStore(
    createRootReducer(),
    initialState,
    composeEnhancers(applyMiddleware(...[promise].concat(...[thunk].concat(...middleware))))
);

store.subscribe(
    _.throttle(() => {
        saveState({
            ...store.getState(),
        });
    }, 1000)
);

// ✅ Vite HMR
if (import.meta.hot) {
    import.meta.hot.accept('./rootReducer', (newModule) => {
        const newRootReducer = newModule?.default;
        if (newRootReducer) {
            store.replaceReducer(newRootReducer());
        }
    });
}

return store;
};

export default configureStore;
